import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Tailwind-aware classNames helper. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** "1234.56" → "1 234,56" — для отображения цены тарифа в UAH. */
export function formatAmount(value: number | string): string {
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString("uk-UA", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/**
 * Українське відмінювання «день»: 1 день, 2 дні, 14 днів, 21 день, 31 день.
 * Повертає лише слово (без числа).
 */
export function ukrDaysWord(n: number): string {
  const mod100 = Math.abs(n) % 100;
  const mod10 = n % 10;
  if (mod100 >= 11 && mod100 <= 14) return "днів";
  if (mod10 === 1) return "день";
  if (mod10 >= 2 && mod10 <= 4) return "дні";
  return "днів";
}

/** ISO date string → "11 травня 2026". */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString("uk-UA", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/**
 * Базова перевірка, що рядок схожий на посилання (не вимагаємо https://):
 * домен із зоною + опційний шлях, без пробілів. Приймає t.me/…, behance.net/…
 */
export function isLikelyUrl(s: string): boolean {
  const t = s.trim();
  if (!t || /\s/.test(t)) return false;
  return /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(\/[^\s]*)?$/i.test(t);
}
